module.exports = __webpack_public_path__ + "img/moneyFooter.8eef7c00.png";